import { render, staticRenderFns } from "./ReactivateRoleDialog.vue?vue&type=template&id=1f253901&scoped=true"
import script from "./ReactivateRoleDialog.vue?vue&type=script&lang=js"
export * from "./ReactivateRoleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f253901",
  null
  
)

export default component.exports